import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers } from '@angular/http';

@Injectable()

export class StatusService {
  public baseUrl: string; 
  constructor(private _http: Http) { 
    this.baseUrl = environment.apiUrl;
  }

  getlistStatus(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'status?page=' + data.page + '&limit=' + data.limit, { headers: headers })
			.map(res => res.json());
	}

  getStatus(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.get(this.baseUrl + 'status/' + data.id, { headers: headers })
			.map(res => res.json());
	}

  editStatus(data: any) {

		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		delete data.auth_token;
		let json = JSON.stringify(data);

		return this._http.put(this.baseUrl + 'status/' + data.id, json, { headers: headers })
			.map(res => res.json());
	}

  newStatus(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'status', json, { headers: headers })
			.map(res => res.json());
	}

	deleteStatus(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.delete(this.baseUrl + 'status/' + data.id, { headers: headers })
			.map(res => res.json());
	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status/status.service.ts